import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostManualsDelete } from '../../../api/manual/manual';
import { useDefaultOptions } from '../../../hooks/api';
import ConfirmModal from '../../modules/ConfirmModal';
import ErrorModal from '../../modules/ErrorModal';
import SpinnerModal from '../../modules/SpinnerModal';

type Props = {
  manualId: number;
  onSearch: () => void;
};
function ManualDelete({ manualId, onSearch }: Props) {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [displaySpinnerModal, setDisplaySpinnerModal] = useState(false);
  const [displayError, setDisplayError] = useState(false);
  const options = useDefaultOptions(language);
  const [isConfirm, setIsConfirm] = useState(false);

  // 削除処理定義
  const { mutateAsync: _deleteAsync, error: deleteError } = usePostManualsDelete(options);

  // 削除処理
  const deleteAsync = useCallback(async () => {
    setDisplaySpinnerModal(true);
    //    const response = await _deleteAsync({ manualId });
    await _deleteAsync({ manualId });
    setDisplaySpinnerModal(false);
    // if (response.status === 200) {
    //   setDisplaySpinnerModal(false);
    // } else {
    //   setDisplaySpinnerModal(false);
    // }
    onSearch();
    setIsConfirm(false);
  }, [_deleteAsync, manualId, onSearch]);

  return (
    <>
      <li onClick={() => setIsConfirm(true)} style={{ cursor: 'pointer' }}>
        <i className="fa-solid fa-circle-xmark" />
        {t('削除')}
      </li>
      {isConfirm && (
        <ConfirmModal onClickOk={() => deleteAsync()} onClickCancel={() => setIsConfirm(false)}>
          <div className="poptxt">
            <p>{t('削除します。よろしいですか？')}</p>
          </div>
        </ConfirmModal>
      )}
      {/* スピナーモーダル */}
      {displaySpinnerModal && <SpinnerModal />}
      {/* 出力エラー */}
      {displayError && <ErrorModal error={deleteError} onClickOk={() => setDisplayError(false)} />}
    </>
  );
}
export { ManualDelete };
